import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const THEMES = [
  'clear-sky',
  'beige',
  'outline',
  'blue',
  'deep-night',
  'clear-night',
  'custom'
]

const PADDING_VARIATIONS = ['standard', 'square', 'square--large']

function ModuleBottomActions ({ actions, extraClass }) {
  return (
    <div className={classnames('module__actions flex flex-wrap', extraClass)}>
      {actions}
    </div>
  )
}
//  b2b-temp - TODO rename actions related props to bottom something
export default function Module ({
  Element = 'section',
  theme,
  withPin,
  padding,
  extraClass,
  extraActionsClass,
  contentExtraClass,
  children,
  actions,
  media,
  ...props
}) {
  const paddingVariation = media ? 'square--large' : padding

  return (
    <Element
      {...props}
      className={classnames(
        {
          'module--with-pin': withPin,
          'bg-clear-sky-blue': theme === 'clear-sky',
          'module--outline': theme === 'outline',
          'bg-deep-night-blue clear-sky-blue': theme === 'deep-night',
          'bg-clear-night-blue clear-sky-blue': theme === 'clear-night',
          'bg-blue clear-sky-blue': theme === 'blue',
          'bg-warm-light-beige-gradient': theme === 'beige',
          'flex flex-column': actions,
          'module--with-media': media
        },
        extraClass,
        'module'
      )}
    >
      <div
        className={classnames(
          {
            'module__content--pb1 flex-grow': actions
          },
          contentExtraClass,
          `module__content--${paddingVariation}`,
          'module__content'
        )}
      >
        {children}
      </div>
      {media}
      {actions && (
        <ModuleBottomActions actions={actions} extraClass={extraActionsClass} />
      )}
    </Element>
  )
}

Module.propTypes = {
  Element: PropTypes.node,
  theme: PropTypes.oneOf(THEMES),
  withPin: PropTypes.bool,
  padding: PropTypes.oneOf(PADDING_VARIATIONS),
  extraClass: PropTypes.string,
  contentExtraClass: PropTypes.string,
  media: PropTypes.node
}

Module.defaultProps = {
  withPin: true,
  padding: 'standard',
  theme: 'clear-sky'
}
